export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";